<template>
	<div class="activity-signature">
		<base-sign ref="refBaseSign" @uploadSucc="signUploadSuccess"></base-sign>
	</div>
</template>

<script>
export default {
	name: 'ActivitySignSignature',
	data: () => ({
		loading: false,
	}),
	computed: {
		user() {
			return this.$store.getters['user/getLoginInfo']
		},
		// 当前登录医生ID
		doctorId() {
			return this.user.userId || this.user.id || ''
		},
	},
	created() {
		this.checkOrientation()
	},
	methods: {
		// 建议横屏签字
		checkOrientation() {
			if (window.orientation != 90 && window.orientation != -90) {
				this.$notify('建议横屏签字，体验更佳')
			}
		},
		// 签名上传成功（url 为 COS Location，不带协议头）
		signUploadSuccess({ url }) {
			switch (this.$route.query.type) {
				// 医生认证签名 / 开播劳务协议签名
				case 'doctorSign':
				case 'playLive':
					sessionStorage.setItem('doctorSignImg', `https://${url}`)
					this.$router.back()
					break
				// 开播劳务协议签名
				case 'meetingAgreement':
					this.meetingAgreement(`https://${url}`)
					break
				// 活动报名签名
				default:
					this.reportActivity(`https://${url}`)
			}
		},
		// 会议劳务协议签名提交
		meetingAgreement(imgUrl) {
			let list = []
			try {
				list = JSON.parse(sessionStorage.getItem('meetingAgreementSpeakerIds')) || []
			} catch (e) {
				list = []
			}
			this.$api.activity
				.xdUploadLaborAgreement({
					laborAgreementSignUrl: imgUrl,
					meetingSpeakerIds: list,
				})
				.then((res) => {
					if (!res.code) {
						this.$toast('提交成功')
						setTimeout(() => this.$router.back(), 500)
					}
				})
		},
		// 活动报名签名提交
		reportActivity(imgUrl) {
			this.loading = true
			const query = this.$route.query
			const reportFormStorage = sessionStorage.getItem('activityReportAuthForm')
			const reportForm = reportFormStorage ? JSON.parse(reportFormStorage) : null
			const formCommitJson = reportForm ? JSON.stringify(reportForm.authForm) : ''
			this.$api.activity
				.reportActivity({
					id: query.relationId,
					activityId: query.activityId,
					doctorId: this.doctorId,
					payType: query.payType || '',
					reportParamBody: {
						formCommitJson,
						doctorAutoAudit: 0,
						isNewInfo: reportForm ? reportForm.isNewInfo : 0,
						hospitalId: reportForm ? reportForm.selectHospitalId : '',
						deptId: reportForm ? reportForm.selectDeptmentId : '',
						activityIdList: [query.activityId],
						codeId: query.codeId || '',
						doctorId: this.doctorId,
						platform: parseInt(query.platform),
						signUrl: imgUrl,
					},
					signUrl: imgUrl,
				})
				.then((res) => {
					this.loading = false
					if (!res.code) {
						if (query.autoAudit == 1) {
							this.$router.replace(`/activity/sign/audit-result?activityId=${query.activityId}&isSubmit=1`)
						} else {
							this.$router.replace(`/activity/sign/audit-result?activityId=${query.activityId}`)
						}
					}
					sessionStorage.removeItem('activityReportAuthForm')
				})
				.catch((error) => {
					console.log('reportActivity error ===>', error)
					this.$toast('服务异常，请稍后重试')
					sessionStorage.removeItem('activityReportAuthForm')
					this.loading = false
				})
		},
	},
}
</script>

<style lang="less" scoped>
.activity-signature {
	min-height: 100vh;
	background-color: #f5f6f7;
}
</style>
